import React from "react";
import {
	ResponsiveContainer,
	LineChart,
	Line,
	CartesianGrid,
	XAxis,
	YAxis,
	Tooltip,
} from "recharts";

interface IProcessData {
	date: string;
	inTransport: number;
	inStorage: number;
	pending: number;
}
interface IProcessChart {
	title: string;
	transportString: string;
	inStorageString: string;
	pendingString: string;
	data: IProcessData[];
}

const ProcessChart = ({
	title,
	transportString,
	inStorageString,
	pendingString,
	data,
}: IProcessChart) => {
	return (
		<div className="background-div" style={{ height: "400px" }}>
			<div
				style={{
					height: "100%",
					width: "100%",
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-between",
					alignContent: "end",
				}}
			>
				<div className="statisticFirst">
					<p className="statisticParagraph">
						<b>{title}</b>
					</p>
					<div className="statisticSecond">
						<p>
							<span className="text-[#4F16C2]">•</span>{" "}
							{transportString}
						</p>
						<p>
							<span className="text-[#FF2828]">•</span>{" "}
							{inStorageString}
						</p>
						<p>
							<span className="text-[#28BFFF]">•</span>{" "}
							{pendingString}
						</p>
					</div>
				</div>
				<ResponsiveContainer width="100%" height="80%">
					<LineChart
						data={data}
						margin={{ top: 20, right: 20, left: 0, bottom: 20 }}
					>
						<CartesianGrid strokeDasharray="3 3" />
						<XAxis dataKey="date" />
						<YAxis />
						<Tooltip />
						{/* <Legend /> */}
						<Line
							type="monotone"
							dataKey="inTransport"
							name="Në transport"
							stroke="#5E49FF"
							strokeWidth={3}
							dot={false}
							activeDot={{ r: 6 }}
						/>
						<Line
							type="monotone"
							dataKey="inStorage"
							name="Në depo"
							stroke="#EB0027"
							strokeWidth={3}
							dot={false}
							activeDot={{ r: 6 }}
						/>
						<Line
							type="monotone"
							dataKey="pending"
							name="Në pritje"
							stroke="#2296FC"
							strokeWidth={3}
							dot={false}
							activeDot={{ r: 6 }}
						/>
					</LineChart>
				</ResponsiveContainer>
			</div>
		</div>
	);
};

export default ProcessChart;
